import { connect } from 'react-redux';

import Component from './ResetPassword.component';

const mapStateToProps = (state) => ({
  state,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
